interface MarkdownLinkNode {
    destination?: string
}

interface MarkdownRendererContext {
    entering: boolean
}

export const markdownViewerOptions = {
    customHTMLRenderer: {
        link (node: MarkdownLinkNode, { entering }: MarkdownRendererContext) {
            if (entering) {
                return {
                    type: 'openTag',
                    tagName: 'a',
                    attributes: {
                        href: node.destination || '',
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                }
            }

            return {
                type: 'closeTag',
                tagName: 'a'
            }
        }
    }
}
